import { createContext } from "react";

const RecordTimeTypeContext = createContext({
  currentTimeType: '',
  setCurrentTimeType: () => {}
});

export default RecordTimeTypeContext;